module.exports = __webpack_public_path__ + "static/img/webBack.f9f7ed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/webBack.png
// module id = SDdF
// module chunks = 1